import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { TokenService, ToastService, ToastType, AppValidationMessages } from '@invessio/ui';
import { ContextService } from '../globalServices/context.service';
import { Router } from '@angular/router';
import { catchError, tap, throwError } from 'rxjs';

import {
  SUCCESS_TOAST,
  SHOW_ERROR_TOAST,
} from '../globalServices/toast-context';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const contextService = inject(ContextService);
  const router = inject(Router);
  const toaster = inject(ToastService);
  const successToast = req.context.get(SUCCESS_TOAST);
  const showErrorToast = req.context.get(SHOW_ERROR_TOAST);

  const token = tokenService.getToken();
  const ctxValue = contextService.ctxParam()?.trim() ?? '';

  const transientAuth = sessionStorage.getItem('transientToken') || '';
  const otpTransientAuth = sessionStorage.getItem('transient-auth') || '';
  const inviteCode = sessionStorage.getItem('inviteCode') || '';

  let modifiedReq = req.clone({
    setHeaders: {
      'Content-Type': 'application/json',
      ...(ctxValue
        ? {}
        : {
          contexttoken:
            'eyJjbGllbnRLZXkiOiJ0ZW5hbnQxIiwgInByb2R1Y3RLZXkiOiJJbnZlc3RtZW50IiwgInByb2R1Y3RUeXBlIjoxfQ==',
        }),
    },
  });

  if (ctxValue && req.url.includes('/api/')) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { contexttoken: ctxValue },
    });
  }

  if (token) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
  if (
    transientAuth &&
    (req.url.includes('/ApplicationConfiguration') ||
      req.url.includes('/User') ||
      req.url.includes('/student/invitation'))
  ) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { transientToken: transientAuth },
    });
  }

  if (otpTransientAuth && req.url.includes('/student/invitation')) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { 'transient-auth': otpTransientAuth },
    });
  } else if (inviteCode && req.url.includes('/student/invitation')) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { 'transient-auth': inviteCode },
    });
  }

  if (inviteCode && req.url.includes('/otpValidation/resend')) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { 'invite-code': inviteCode },
    });
  }

  if (
    inviteCode &&
    (
      req.url.includes('/auth/RegisterApplicant') ||
      req.url.includes('/auth/RegisterCoBorrower') ||
      req.url.includes('/auth/IsRegisteredUser')
    )
  ) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { 'transient-auth': inviteCode },
    });
  }

  return next(modifiedReq).pipe(
    tap((event) => {
      if (
        event instanceof HttpResponse &&
        (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE' || req.method === 'PATCH') &&
        successToast
      ) {
        toaster.show(successToast, ToastType.Success);
      }
    }),

    catchError((error: HttpErrorResponse) => {
      if (showErrorToast) {
        const errorMessage =
          error.error?.errors?.[0]?.message ??
          error.error?.title ??
          AppValidationMessages.SOMETHING_WENT_WRONG_MSG;

        toaster.show(errorMessage, ToastType.Error);
      }

      if (error.status === 401) {
        router.navigate(['/auth']);
      } else if(error?.status === 403 && error?.error === 'OTP required'){
        router.navigate(['otp']);
      }
      else if (req.method === 'GET' && error?.error !== 'OTP required') {
        const status = [403, 404, 500].includes(error.status)
          ? error.status
          : 500;

        router.navigate(['/error'], {
          queryParams: { status },
        });
      }
      return throwError(() => error);
    })
  );

};
